// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2pjDQ","upload":"Small_upload__nrA0x","imageWrap":"Small_imageWrap__1ZuXt","removeBtn":"Small_removeBtn__2icOZ"};